import { cn } from "@/lib/utils"
import React from "react"

const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, children, ...props }, ref) => (
  <label ref={ref} className={cn("h-label", className)} {...props}>
    {children}
  </label>
))
Label.displayName = "Label"

export { Label }
